export default {
  middleware_url: "https://v2.livraisons.pro",
  cake_url: "https://v2.back.livraisons.pro",
  pwa_url: "https://app.v2.livraisons.pro/",
  isWavesoftEnabled: true,
  isUrbantzEnabled: true,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "24",
  googleMap: {
    api: "AIzaSyCPQ-mWkw-QJAiIsfx23XnY-5-uWhw3vsE",
  },
};
